







































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RetensiSession } from "@/types/RetensiAlihMedia";
import { toDateInputs } from "@/utils/localDate";

@Component({ name: "RetensiStepIdentitas" })
export default class StepIdentitas extends Vue {
  @Prop({ type: Object, required: true }) value!: Partial<RetensiSession>;
  @Prop({ type: Object, default: null }) existingSession!: RetensiSession | null;

  valid = false;

  jenjangOpts = [
    { value: "d3_rmik", text: "D3 RMIK" },
    { value: "d4_mik", text: "D4 MIK" },
    { value: "s1_mik", text: "S1 MIK" },
    { value: "s2", text: "S2" },
  ];

  get form(): Partial<RetensiSession> {
    return this.value;
  }

  required = (v: any) => (!!v && v !== "" && v !== 0) || "Wajib diisi";

  strValid = (v: string) => {
    if (!v || !this.form.tanggal_audit) return true;
    return (
      new Date(v) >= new Date(this.form.tanggal_audit) ||
      "STR PMIK kadaluwarsa pada tanggal audit"
    );
  };

  sikValid = (v: string) => {
    if (!v || !this.form.tanggal_audit) return true;
    return (
      new Date(v) >= new Date(this.form.tanggal_audit) ||
      "SIK PMIK kadaluwarsa pada tanggal audit"
    );
  };

  differentFromPmik = (v: number) => {
    return (
      !v ||
      !this.form.pmik_pelaksana_id ||
      v !== this.form.pmik_pelaksana_id ||
      "PMIK tidak boleh merangkap Auditor (conflict of interest)"
    );
  };

  @Watch("existingSession", { immediate: true })
  onExistingChange(s: RetensiSession | null) {
    if (s) {
      Object.assign(this.form, toDateInputs(s));
    }
  }

  @Watch("form", { deep: true })
  onFormChange() {
    (this.$refs.form as any)?.validate();
  }
}
